import React, { useEffect, useState } from "react";

function remainingLabel(ms) {
	if (ms <= 0) return "agora";
	const totalSeconds = Math.ceil(ms / 1000);
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;
	const pad = (n) => String(n).padStart(2, "0");
	if (hours > 0) return `${hours}h ${pad(minutes)}min`;
	return `${pad(minutes)}:${pad(seconds)}`;
}

export default function FollowUpCountdown({ ticket }) {
	const stage = ticket?.followUpStage;
	const dueRaw = ticket?.followUpDueAt;
	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		if (!stage || !dueRaw) return undefined;
		const timer = setInterval(() => setNow(Date.now()), 1000);
		return () => clearInterval(timer);
	}, [stage, dueRaw]);

	if (!stage || !dueRaw) return null;

	const due = new Date(dueRaw).getTime();
	if (Number.isNaN(due)) return null;

	const waitingMessage = stage === "waiting_message";
	const text = waitingMessage
		? "Follow-up aguardando para enviar a mensagem"
		: "Follow-up aguardando para aplicar a ação";

	return (
		<div className="mx-3 mt-2 flex items-center justify-between gap-3 rounded-xl border border-amber-300 bg-amber-50 px-3 py-2 text-amber-950 dark:border-amber-700/60 dark:bg-amber-950/40 dark:text-amber-100">
			<p className="m-0 text-sm font-medium">{text}</p>
			<span className="shrink-0 rounded-full bg-amber-200 px-2.5 py-1 text-sm font-semibold tabular-nums dark:bg-amber-800">
				{remainingLabel(due - now)}
			</span>
		</div>
	);
}
